import React, { useEffect, useState } from "react";
import { Steps, Button, Form, Input, Row, Col, Upload, InputNumber, Select, DatePicker, message, Modal } from "antd";
import { ProgressBar } from "components/ProgressBar";
import { DeleteOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { addPerformance, getPerformance, getVideo, addVideo, addhistory, gethistory, ChangePerformance, deleteVideo } from "store/auth/profile/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import moment from "moment";
import { BASE_URL } from "helpers/api_helper";
const { Step } = Steps;

const MultiStepForm = () => {
  const { RangePicker } = DatePicker; // Extract RangePicker from DatePicker
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(0);
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const performance = useSelector(state => state.Profile.performance);
  const videos = useSelector(state => state.Profile.videos);
  const profile = useSelector((state) => state.Profile.profile);
  const history = useSelector((state) => state.Profile.history);
  // console.log("all stats ", videos, history, performance);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        await dispatch(getPerformance());
        await dispatch(getVideo());
        const id = profile?._id;
        // console.log(id);
        if (id) {
          await dispatch(gethistory(id));
        }

      } catch (err) {
        console.error(err);
        message.error("Erreur lors du chargement des données.");
      }
    };

    fetchAll();
  }, [dispatch, profile, current]);

  useEffect(() => {
    const fetchAll = async () => {
      const perfs = await performance?.performances;
      if (perfs?.length > 0) {
        const stats = perfs[0]?.statistics;
        form.setFieldsValue({
          trophies: perfs[0].trophies,
          individualTitles: perfs[0].individualTitles,
          goalsScored: stats.goalsScored,
          assists: stats.assists,
          cardsReceived: stats.cardsReceived,
          minutesPlayed: stats.minutesPlayed,
        });
        // console.log(perfs, stats,
        //   form.getFieldsValue([
        //     "trophies",
        //     "individualTitles",
        //     "goalsScored",
        //     "assists",
        //     "cardsReceived",
        //     "minutesPlayed",
        //   ])
        // );
      }

      // Pour les vidéos
      const vids = await videos;
      const existing = vids.map(v => ({
        uid: v._id,
        name: v.url.split(/[/\\]/).pop(),
        status: "done",
        url: v.url,
        originFileObj: null,
      }));
      setFileList(existing);
      form.setFieldsValue({ video: existing });

      // Pour l'historique
      const id = profile?._id;
      if (id) {
        // console.log(history);
        const hist = await history?.history[0];
        if (hist) {
          form.setFieldsValue({
            clubName: hist?.clubName,
            role: hist?.position,
            category: hist?.category,
            period: hist?.dateRange
              ? [
                moment(hist?.dateRange?.startDate),
                moment(hist?.dateRange?.endDate)
              ]
              : [],
            matchesPlayed: hist?.matchesPlayed,
            goalsScored: hist?.goalsScored,
            assists: hist?.assists
          });
        }
      }
    };

    fetchAll();
  }, [dispatch, form, performance, videos, profile, history]);

  const [percentage, setPercentage] = useState(0);
  const [completed, setCompleted] = useState(0);
  useEffect(() => {
    let completed = 0;
    // console.log(performance, videos, history);
    if (performance && performance.performances && performance.performances.length > 0) {
      setCompleted(1);
    }
    if (videos && Array.isArray(videos) && videos.length > 0) {
      setCompleted(2);
    }
    if (history && history.history && history.history.length > 0) {
      setCompleted(3);
    }
    const totalSteps = 3;
    const computedPercentage = Math.round((completed / totalSteps) * 100);
    setPercentage(computedPercentage);
  }, [performance, videos, history]);

  useEffect(() => {
    if (completed === 0) {
      setCurrent(0);
    } else if (completed === 1) {
      setCurrent(1);
    } else {
      setCurrent(2);
    }
  }, [completed])


  const onChange = ({ fileList: newList }) => {
    // console.log("Upload onChange:", newList);
    setFileList(newList);
    form.setFieldsValue({ video: newList });
  };

  const onRemove = async file => {
    const newList = fileList.filter(item => item.uid !== file.uid);
    await handleDelete(file.uid);
    setFileList(newList);
    form.setFieldsValue({ video: newList });
  };

  const handleDelete = async (id) => {
    try {
      const response = await dispatch(deleteVideo(id));
      if (response.status === 200) {
      } else {
        // message.error('Error deleting video');
      }
      message.success('Video deleted successfully');
      dispatch(getVideo());
    } catch (error) {
      message.error(error.message);
    }
  };

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewVideo, setPreviewVideo] = useState(null);

  const handlePreview = async file => {
    // Génère une URL objet si ce n'est pas déjà fait
    if (!file.url && !file.preview) {
      file.preview = URL.createObjectURL(file.originFileObj);
    }

    if (file.url) {
      setPreviewVideo(`${BASE_URL}/${file.url.replace(/\\/g, '/')}`);
    } else {
      setPreviewVideo(`${BASE_URL}/${file.preview.replace(/\\/g, '/')}`);
    }
    setPreviewVisible(true);
  };

  const handleModalClose = () => {
    setPreviewVisible(false);
    // Optionnellement libérer l'URL
    // URL.revokeObjectURL(previewVideo);
    setPreviewVideo(null);
  };

  const trophiesOptions = [
    "Algerian Cup",
    "Champions League",
    "CAF Cup",
    "Ligue 1 Mobilis",
    "Arab Cup",
    "Friendly Matches",
    "National Talent Tournament",
    "Regional League Cup",
  ];
  const steps = [
    {
      title: "performance",
      content: (
        <div>
          <ProgressBar percentage={percentage} />
          <Form form={form} layout="vertical">
            <Row gutter={16} className="mt-5" style={{ marginBottom: '20px' }}>
              <Col span={12}>
                <Form.List name="trophies">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Form.Item
                          {...restField}
                          key={key}
                          name={name}
                          label={name === 0 ? "Trophées remportés" : ""}
                          rules={[
                            { required: true, message: "Veuillez sélectionner un trophée" },
                          ]}
                        >
                          <div style={{ display: "flex", gap: "10px" }}>
                            <Select
                              placeholder="Sélectionner un trophée"
                              options={trophiesOptions.map((trophy) => ({
                                label: trophy,
                                value: trophy,
                              }))}
                              value={form.getFieldValue(['trophies', name])}
                              onChange={(value) => form.setFieldValue(['trophies', name], value)}
                              style={{ flex: 1 }}
                            />
                            <Button
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            />
                          </div>
                        </Form.Item>
                      ))}
                      <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                        Ajouter un trophée
                      </Button>
                    </>
                  )}
                </Form.List>
              </Col>
              <Col span={12}>
                <Form.List name="individualTitles">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Form.Item
                          {...restField}
                          key={key}
                          name={name}
                          label={name === 0 ? "Titres individuels" : ""}
                          rules={[{ required: true, message: "Veuillez sélectionner un titre" }]}
                        >
                          <div style={{ display: "flex", gap: "10px" }}>
                            <Select
                              style={{ flex: 1 }}
                              value={form.getFieldValue(['individualTitles', name])}
                              onChange={(value) => form.setFieldValue(['individualTitles', name], value)}
                            >
                              <Select.Option value="Top Scorer">Top Scorer</Select.Option>
                              <Select.Option value="Man of the Match">Man of the Match</Select.Option>
                              <Select.Option value="Best Player">Best Player</Select.Option>
                            </Select>
                            <Button
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            />
                          </div>
                        </Form.Item>
                      ))}
                      <Button type="dashed" onClick={() => add()} block>
                        + Ajouter un titre individuel
                      </Button>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>
            <div className="d-flex justify-content-center p-3">
              <h3> Statistiques clés </h3>
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="goalsScored"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value === undefined || value === null || typeof value === "number") {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Veuillez entrer un nombre valide"));
                      },
                    }),
                  ]}
                >
                  <InputNumber placeholder="Nombre de buts marqués" min={0} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="assists"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value === undefined || value === null || typeof value === "number") {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Veuillez entrer un nombre valide"));
                      },
                    }),
                  ]}
                >
                  <InputNumber placeholder="Passes décisives" min={0} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="cardsReceived"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value === undefined || value === null || typeof value === "number") {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Veuillez entrer un nombre valide"));
                      },
                    }),
                  ]}
                >
                  <InputNumber placeholder="Cartons reçus" min={0} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='minutesPlayed'
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value === undefined || value === null || typeof value === "number") {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Veuillez entrer un nombre valide"));
                      },
                    }),
                  ]}
                >
                  <InputNumber placeholder="Minutes jouées" min={0} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      ),
    },
    {
      title: "vidéo",
      content: (
        <div>
          <ProgressBar percentage={percentage} />
          <Form form={form} layout="vertical">
            <h4>
              Mettez en avant vos compétences sur le terrain en téléchargeant une vidéo de votre
              meilleure performance.
            </h4>
            <Form.Item
              name="video"
              label="Vos vidéos"
              rules={[{ required: true, message: "Veuillez sélectionner une vidéo." }]}
            >
              <Upload
                accept="video/*"
                beforeUpload={() => false}
                fileList={fileList}
                onChange={onChange}
                onRemove={onRemove}
                listType="picture"
                // listType="picture-card"
                onPreview={handlePreview}
              >
                <Button icon={<UploadOutlined />}>Ajouter une vidéo</Button>
              </Upload>
            </Form.Item>
          </Form>
          <Modal
            open={previewVisible}
            footer={null}
            onCancel={handleModalClose}
            width="60%"
            styles={{
              body: { padding: 0 }
            }}
          >
            {previewVideo && (
              <video
                style={{ width: '100%' }}
                controls
                src={previewVideo}
              />
            )}
          </Modal>
        </div>
      ),
    },
    {
      title: "Experience",
      content: (
        <div>
          <ProgressBar percentage={percentage} />
          <Form form={form} layout="vertical">
            <div className="d-flex justify-content-center p-3">
              <h4>Ajoutez une expérience professionnelle ou sportive.</h4>
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="clubName" label="Nom de l'équipe ou du club" rules={[{ required: true, message: "Veuillez entrer un nom" }]}>
                  <Input placeholder="Ex: FC Barcelone" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="role" label="Poste ou rôle" rules={[{ required: true, message: "Veuillez entrer un poste" }]}>
                  <Input placeholder="Ex: Attaquant, Milieu de terrain, Coach" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="category" label="Catégorie" rules={[{ required: true, message: "Veuillez sélectionner une catégorie" }]}>
                  <Select placeholder="Choisir une catégorie">
                    <Select.Option value="U6-U7">U6-U7</Select.Option>
                    <Select.Option value="U8-U9">U8-U9</Select.Option>
                    <Select.Option value="U10-U11">U10-U11</Select.Option>
                    <Select.Option value="U12-U13">U12-U13</Select.Option>
                    <Select.Option value="U14-U15">U14-U15</Select.Option>
                    <Select.Option value="U16-U17">U16-U17</Select.Option>
                    <Select.Option value="U18-U19">U18-U19</Select.Option>
                    <Select.Option value="Senior">Senior</Select.Option>
                    <Select.Option value="Professional">Professional</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="period" label="Période" rules={[{ required: true, message: "Veuillez sélectionner la période" }]}>
                  <RangePicker picker="year" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
            <div className="d-flex gap-3">
              <Form.Item name="matchesPlayed" label="Matchs joués" rules={[{ required: true, message: "Entrez le nombre de matchs" }]}>
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item name="goalsScored" label="Buts marqués" rules={[{ required: true, message: "Entrez le nombre de buts" }]}>
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item name="assists" label="Passes décisives" rules={[{ required: true, message: "Entrez le nombre de passes" }]}>
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </div>
          </Form>
        </div>
      ),
    },
  ];

  const handleFinish = async () => {
    const values = form.getFieldsValue();
    // console.log(values);

    const dateRange = {
      startDate: values.period && values.period[0] ? values.period[0].format("YYYY-MM-DD") : null,
      endDate: values.period && values.period[1] ? values.period[1].format("YYYY-MM-DD") : null
    };

    const formData = {
      dateRange: dateRange,
      category: values.category,
      clubName: values.clubName,
      position: values.role,
      matchesPlayed: values.matchesPlayed || 0,
      goalsScored: values.goalsScored || 0,
      assists: values.assists || 0,
    };

    const id = profile._id;

    try {
      const response = await dispatch(addhistory({ formData, id }));
      if (!response.error) {
        // console.log("Historique ajouté avec succès:", response.payload);
        await dispatch(gethistory(id));
        message.success('history added successfully');
      } else {
        message.error('error');
        console.error("Erreur lors de l'ajout:", response);
      }
    } catch (error) {
      console.error("Exception lors de l'ajout d'historique:", error);
    }
  };

  const next = async () => {
    if (current === 0) {
      const perfomanceData = form.getFieldsValue([
        "trophies",
        "individualTitles",
        "goalsScored",
        "assists",
        "cardsReceived",
        "minutesPlayed",
      ]);
      const formatData = {
        trophies: perfomanceData.trophies || [],
        individualTitles: perfomanceData.individualTitles || [],
        statistics: {
          goalsScored: perfomanceData.goalsScored || 0,
          assists: perfomanceData.assists || 0,
          cardsReceived: perfomanceData.cardsReceived || 0,
          minutesPlayed: perfomanceData.minutesPlayed || 0,
        }
      };
      try {
        if (performance?.performances?.[0]) {
          const response = await dispatch(ChangePerformance(formatData))
          dispatch(getPerformance());
          const err = response.payload.response.data.message;
          if (response.error) {
            message.error(err);
          } else {
            message.success('perfomance updated succussfully');
          }
        } else {
          const response = await dispatch(addPerformance(formatData));
          const err = response.payload.response.data.message;
          if (response.error) {
            message.error(err);
          } else {
            message.success('perfomance added succussfully');
          }
        }

      } catch (error) {
        console.log(error);
      }

    } else if (current === 1) {
      try {
        await form.validateFields(["video"]);
      } catch {
        return;
      }
      const toUpload = fileList.filter(f => f.originFileObj);
      if (toUpload.length === 0) {
        setCurrent(2);
        return;
      }

      const formData = new FormData();
      formData.append("video", toUpload[0].originFileObj);
      try {
        await dispatch(addVideo(formData));
        message.success("Vidéo téléchargée avec succès");
        setCurrent(2);
      } catch (err) {
        console.error(err);
        message.error("Échec du téléchargement.");
      }
    }

    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  return (
    <div style={{ maxWidth: 600, margin: "auto" }}>
      <Steps current={current}>
        {steps.map((step, index) => (
          <Step key={index} title={step.title} />
        ))}
      </Steps>
      <div style={{ marginTop: 20 }}>{steps[current].content}</div>
      <div className="d-flex justify-content-lg-between" style={{ marginTop: 20 }}>
        <Button onClick={prev} style={{ marginRight: 10 }}
          disabled={current <= 0 || (performance.length > 0 && current == 1)}
        >
          Back
        </Button>
        {current < steps.length - 1 &&
          <Button type="primary"
            style={{ display: current == 2 ? 'none' : null }}
            onClick={next}>Next
          </Button>}
        {current === 2 && <Button type="primary" onClick={handleFinish}>Submit</Button>}
      </div>
    </div>
  );
};

export default MultiStepForm;
